"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var DELAY = 200;

var _default = function _default(_ref) {
  var onClick = _ref.onClick,
      onDoubleClick = _ref.onDoubleClick;
  var timerRef = (0, _react.useRef)();
  var preventRef = (0, _react.useRef)(false);

  if (!onDoubleClick) {
    return {
      onClick: onClick,
      onDoubleClick: onDoubleClick
    };
  }

  var handleClick = function handleClick(e) {
    e.stopPropagation();
    var event = e;
    preventRef.current = false;
    timerRef.current = setTimeout(function () {
      if (!preventRef.current) {
        onClick(event);
      }
    }, DELAY);
  };

  var handleDoubleClick = function handleDoubleClick(e) {
    clearTimeout(timerRef.current);
    preventRef.current = true;
    onDoubleClick(e);
  };

  return {
    onClick: handleClick,
    onDoubleClick: handleDoubleClick
  };
};

exports["default"] = _default;
//# sourceMappingURL=doubleClick.js.map